<template>
  <Btn :label="label" icon="mdi-table-plus" :disabled="disabled" isCheckRole @click="onClick" />
</template>

<script>
import Btn from '@/components/atoms/base/button/Btn'

export default {
  name: 'BtnAdd',

  components: {
    Btn,
  },

  props: {
    label: {
      type: String,
      required: false,
      default: function () {
        return this.$t('ELE0016')
      },
    },
    disabled: {
      type: Boolean,
      required: false,
      default: false,
    },
  },

  methods: {
    onClick() {
      this.$emit('click')
    },
  },
}
</script>
